module.exports = __webpack_public_path__ + "img/zuijia_19.7b7b2ea6.png";